import {
    REQUEST_BILLING_ORDER_NUMBER_DETAILS,
    REQUEST_BILLING_ORDER_NUMBER_DETAILS_FAILURE,
    REQUEST_BILLING_ORDER_NUMBER_DETAILS_SUCCESS
} from "../../../constant/transaction/BillingDetailContant";


const initialState = {
    billingOrderNumberDetails: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingOrderNumberDetailsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLING_ORDER_NUMBER_DETAILS:
            return {
                ...state,
                billingOrderNumberDetails: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLING_ORDER_NUMBER_DETAILS_SUCCESS:
            return {
                ...state,
                billingOrderNumberDetails: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLING_ORDER_NUMBER_DETAILS_FAILURE:
            return {
                ...state,
                billingOrderNumberDetails: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
